import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.scss']
})
export class AdminUserComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) table: TableComponent;
  public uuid;

  constructor(private http: HttpService, private route: ActivatedRoute, private cdr : ChangeDetectorRef) {
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['company_uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.uuid = val;
      } else {
        this.uuid = null;
      }
    })   
   }

  ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/user/get", data: {uuid: this.uuid}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Name', type: 'string', key: 'name'}, 
            {label: 'Username', type: 'string', key: 'username'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'Create By', type: 'string', key: 'create_by_title'}, 
            {label: 'Create On', type: 'date', key: 'timestamp'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/admin/user/form' + (this.uuid ? '/' + this.uuid : '/null'), hide: true, hide_super_admin: true, hide_create_by_me: true},
            {label: 'Delete', type: 'delete', key: this.uuid ? 'au_uuid' : 'uuid', table: this.uuid ? 'admin_user_company' : 'admin_user', title: 'name', hide: true, hide_super_admin: true, hide_create_by_me: true},
          ]}
        this.table.init(setting);
      this.cdr.detectChanges();
  }


}
